import React from 'react';

import './css/MapCard.css';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Coordinate, MapMessage, TaskCoordinate } from 'types/interfaces';

import MapComponent from './shared/MapComponent';
import UnavailableCoordinatesList from './shared/UnavailableCoordinatesList ';

interface MapCardProps {
  openTime: string | null;
  relevantCoordinates?: Coordinate[];
  expiredCoordinates?: Coordinate[];
  invalidTasks?: TaskCoordinate[];
  validTasks?: TaskCoordinate[];
  loading?: boolean;
  mapMessage: MapMessage;
  isMobile?: boolean
}

const MapCard: React.FC<MapCardProps> = ({
  openTime,
  relevantCoordinates,
  expiredCoordinates,
  invalidTasks,
  validTasks,
  loading,
  mapMessage,
  isMobile
}) => {
  return (
    <>
      {loading ? (
        <ProgressSpinner />
      ) : (
        <div className="map-card h-full flex flex-column">
          <div className={`flex ${isMobile ? 'flex-column align-items-start' : 'align-items-center'} gap-2`}>
            {openTime && (
              <p className={isMobile ? 'mt-2' : 'mr-4'}>
                Дата и время последнего обновления данных:{' '}
                <strong>{openTime}</strong>
              </p>
            )}
            <Message severity={mapMessage?.severity} text={mapMessage?.text} />
          </div>

          <div style={{ position: 'relative', flexGrow: 1 }}>
            <MapComponent
              relevantCoordinates={relevantCoordinates}
              validTasks={validTasks}
            />

            {invalidTasks && invalidTasks.length > 0 && (
              <UnavailableCoordinatesList
                key="task"
                expiredCoordinates={invalidTasks}
                title="Отсутствуют координаты нарядов:"
                verticalMargin={50}
                verticalPosition="top"
              />
            )}

            {expiredCoordinates && expiredCoordinates.length > 0 && (
              <UnavailableCoordinatesList
                key="employee"
                expiredCoordinates={expiredCoordinates}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MapCard;
